// Resolves an opaque storage key to a URL the browser can fetch.
//
// Production storage keys are short opaque identifiers (e.g.
// `members/<id>/<uuid>`). They are routed through the API so it can
// presign / proxy / authorise the underlying object-store fetch.
//
// Seed and demo data may store a fully-qualified URL directly in the
// same column (e.g. `https://images.unsplash.com/photo-...`). Those are
// already directly fetchable, so we pass them through unchanged.
//
// One module owns this rule so every projection that surfaces a member
// photo / group cover / event hero URL agrees on it. Lives in shared so
// apps/web (server components, mappers) and apps/server (projections)
// import the same source.
const ABSOLUTE_URL_PREFIXES = ['https://', 'http://'];
export function isAbsoluteMediaUrl(value) {
    return ABSOLUTE_URL_PREFIXES.some((p) => value.startsWith(p));
}
export function mediaUrlFromKey(key) {
    if (key === null)
        return null;
    if (isAbsoluteMediaUrl(key))
        return key;
    return `/api/v1/media/${encodeURIComponent(key)}`;
}
export function photoUrlFromKey(key, status) {
    if (key === null)
        return null;
    if (isAbsoluteMediaUrl(key))
        return key;
    if (status !== 'available')
        return null;
    return `/api/v1/media/${encodeURIComponent(key)}`;
}
//# sourceMappingURL=media-url.js.map